const barbaBeforeEnterFunctions = (data) => {
  
  /***************************************************************
    UPDATE BODY CLASSES
  ***************************************************************/
  
  const nextData = data.next.html;
    
  $('body').removeClass();
  $('body').addClass(nextData.match(/<body.+?class="([^""]*)"/i)[1]);
  
  const $newPageHead = $( '<head />' ).html(
    $.parseHTML(
        nextData.match(/<head[^>]*>([\s\S.]*)<\/head>/i)[0]
      , document
      , true
    )
  );
  
  const headTags = [
      "meta[name='keywords']"
    , "meta[name='description']"
    , "meta[property^='og']"
    , "meta[name^='twitter']"
    , "meta[itemprop]"
    , "link[itemprop]"
    , "link[rel='prev']"
    , "link[rel='next']"
    , "link[rel='canonical']"
    , "link[id='va2022-builder-styles-css']"
  ].join(',');
  $( 'head' ).find( headTags ).remove(); // Remove current head tags
  $newPageHead.find( headTags ).prependTo( 'head' ); // Append new tags to the head
  
}

export {
  barbaBeforeEnterFunctions
};
